<template>
  <div>
    <el-row class="mb-20">
      <el-col :span="24">
        <el-table
          :data="bookings"

          style="width: 100%"
          stripe
          :row-class-name="getClassnameById"
          class="item-table hidden-sm-and-down"
        >
          <el-table-column
            label="Event"
            min-width="250"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.entityType === 'event' ? scope.row.event.name : scope.row.venue.name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Ticket Type"
            min-width="250"
            prop="entityType"
          />
          <el-table-column
            label="Name"
            min-width="250"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.bookingSlot.name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Quantity"
            min-width="250"
          >
            <template slot-scope="scope">
              <div>{{ getSlot(scope.row.bookingSlot._id, scope.row.slots).quantity }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="Effective Date"
            min-width="300"
          >
            <el-table-column
              label="From"
              min-width="150"
            >
              <template slot-scope="scope">
                <div>{{ dateFormatter(scope.row.bookingSlot.effectiveDate.from) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="To"
              min-width="150"
            >
              <template slot-scope="scope">
                <div>{{ dateFormatter(scope.row.bookingSlot.effectiveDate.to) }}</div>
              </template>
            </el-table-column>
          </el-table-column> -->
          <!-- <el-table-column
            label="Active"
            min-width="250"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.bookingSlot.isActive ? 'Yes' : 'No'}}</div>
            </template>
          </el-table-column> -->
          <el-table-column
            label="Price"
            min-width="250"
          >
            <template slot-scope="scope">
              <div>{{ getSlot(scope.row.bookingSlot._id, scope.row.slots).price | parsePrice }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Total Cost"
            min-width="250"
          >
            <template slot-scope="scope">
              <div>{{ getTotalCost(getSlot(scope.row.bookingSlot._id, scope.row.slots))| parsePrice }}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'Bookings',
  props: {
    value: Object,
  },
  data() {
    return {
      bookings: [],
    };
  },
  async mounted() {
    const memberId = this.value._id;
    if (memberId) {
      const res = await this.$http.get(`/assemble/api/v1/portal/bookings/members/${memberId}`);
      this.bookings = res.data.data;
    }
  },
  filters: {
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
  },
  methods: {
    dateFormatter(timestamp) {
      return this.moment(timestamp).format('DD/MM/YYYY HH:mm');
    },
    getClassnameById({ row }) {
      return `${row._id}`;
    },
    getSlot(slotId, slots) {
      return slots.find((slot) => slot.slotId === slotId);
    },
    getTotalCost(slot) {
      return slot.price * slot.quantity;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding-top: 2em;
    text-align: left;
  }
}

</style>
